const config = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG_JSON)
const api = process.env.VUE_APP_API_URL
const isDev =
  api === 'https://asia-northeast1-spotwork-dev-5da3e.cloudfunctions.net'
const siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY
const stripePublishKey = process.env.VUE_APP_STRIPE_PUBLISH_KEY

export { config, api, isDev, siteKey, stripePublishKey }
